<div class="fixed inset-0 z-50 bg-background/80 backdrop-blur-xs" >
  <!-- (click)="close()" -->
  <div
    class="fixed left-[50%] top-[50%] z-50 grid max-w-lg w-full translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 sm:rounded-lg"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden"
      (click)="close()"
    >
      <ng-icon name="lucideX" class="w-4 h-4"></ng-icon>
    </button>

    <div class="flex flex-col space-y-1.5 text-center sm:text-left">
      <h2 class="text-lg font-semibold leading-none tracking-tight">
        <ng-content select="[modal-title]"></ng-content>
      </h2>
    </div>

    <ng-content select="[modal-content]"> </ng-content>
  </div>
</div>
